import React from 'react'
import { connect } from 'react-redux'
import { toast } from 'react-toastify'

const toastApolloError = ({ graphQLErrors, networkError, message }) => {
  let toastMethod
  let toastHeader
  let toastMessage = message
  let toastDetails
  let autoClose = false

  if (networkError) {
    toastMethod = toast.error
    toastHeader = 'Network Error'
    toastMessage = `${networkError.name} - ${networkError.statusCode ? networkError.statusCode : networkError.type}`
    if (networkError.result && networkError.result.errors) {
      toastDetails = networkError.result.errors.map(({ extensions, message }) => (<p>{extensions.code}: {message}</p>))
    } else if(networkError.message) {
      toastMessage = <p>{message}</p>
    }
  } else if (graphQLErrors) {
    if(graphQLErrors[0].extensions.code === 'BAD_USER_INPUT') {
      toastMethod = toast.info
      toastHeader = 'Validation error'
      toastMessage = graphQLErrors.map(({message, locations, path}) => <p>{message}</p>)
      autoClose = true
    } else {
      toastMethod = toast.warn
      toastHeader = 'GraphQL Error'
      toastDetails = graphQLErrors.map(({message, locations, path}) => <p>{path}: {message}</p>)
    }
  } else {
    toastMethod = toast.error
    toastHeader = 'System Error'
  }

  const toastContent = (
    <div>
      <p>
        <strong>{toastHeader}</strong>
      </p>
      <div>{toastMessage}</div>
      {toastDetails && (<div>{toastDetails}</div>)}
    </div>
  )

  toastMethod(toastContent, { autoClose })

  return null
}

// can be used as 'onError' handler on <Query.. or as error handler on promises/catch-blocks
export const onApolloError = (dispatch, apolloError) => toastApolloError(apolloError)

// can be used as element return value from <Query... callback when 'error' is non-null
export const GraphqlError = connect()(({ dispatch, error: apolloError }) => toastApolloError(apolloError))




// WEBPACK FOOTER //
// ./util/GraphqlError.js